import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import MusicPlayer from "@/components/MusicPlayer";
import Landing from "@/pages/Landing";
import AccessCode from "@/pages/AccessCode";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Membership from "@/pages/Membership";
import InfluencerLogin from "@/pages/InfluencerLogin";
import InfluencerApply from "@/pages/InfluencerApply";
import EventPage from "@/pages/Event";
import GuestList from "@/pages/GuestList";
import AccessGranted from "@/pages/AccessGranted";
import Dashboard from "@/pages/Dashboard";
import InfluencerDashboard from "@/pages/InfluencerDashboard";
import Vault from "@/pages/Vault";
import Admin from "@/pages/Admin";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refund from "@/pages/Refund";
import "@/index.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <MusicPlayer />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/access-code" element={<AccessCode />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/influencer/login" element={<InfluencerLogin />} />
          <Route path="/influencer/apply" element={<InfluencerApply />} />
          <Route path="/influencer/dashboard" element={<InfluencerDashboard />} />
          <Route path="/event/:id" element={<EventPage />} />
          <Route path="/guest-list/:eventId" element={<GuestList />} />
          <Route path="/access-granted" element={<AccessGranted />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/vault" element={<Vault />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund" element={<Refund />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
